import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import DialogTitle from './DialogTitle';

const DialogActions = withStyles(() => ({
    root: {
        padding: 24,
        justifyContent: 'flex-start',
        boxShadow: '0px -12px 9px -12px #CCC',
    },
}))(MuiDialogActions);

const StyledDialog = withStyles(() => ({
    paper: {
        borderRadius: 16,
        width: 424,
        height: 705,
        overflow: 'hidden',
    },
}))(Dialog);

const StyledDialogTitle = withStyles(() => ({
    root: {
        height: 69,
        paddingTop: 24,
    },
}))(DialogTitle);

/**
 * @component
 * @description A Dialog (Modal) component based on Material UI lib with some modifications made to Title styles and how action buttons are displayed
 * @param {Object} props
 * @param {JSX} props.children content rendered inside Dialog
 * @param {Object} props.contentStyle additional style added to content
 * @param {String} props.maxWidth size of component (width). It could be one of those: 'xs', 'sm', 'md' (default), 'lg' or 'xl'
 * @param {Function} props.onClose function called when the Dialog is dismissed by pressing the Esc key or the X button at the top
 * @param {Array} props.options Material UI Buttons for confirming or dismissing the dialog for example
 * @param {String} props.title title on the dialog. Can also be empty
 * @param {Boolean} props.visible when *false* the dialog is hidden and displayed when *true*
 */
const MaterialDialog = ({
    children,
    contentStyle = {},
    maxWidth = 'xs',
    onClose = () => {},
    options = [],
    title = '',
    visible = false,
}) => {
    return (
        <StyledDialog
            open={visible}
            fullWidth={true}
            maxWidth={maxWidth}
            onClose={onClose} // Esc key callback
            scroll="paper"
        >
            <StyledDialogTitle id="scroll-dialog-title" onClose={onClose}>
                {title}
            </StyledDialogTitle>
            <DialogContent style={contentStyle}>{children}</DialogContent>
            <DialogActions>{options}</DialogActions>
        </StyledDialog>
    );
};

export default MaterialDialog;
